export default "__VITE_ASSET__Dedqn69x__"